export default [
  {
    name: "Core",
    poolAddress: "0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2",
  },
  {
    name: "Prime",
    poolAddress: "0x4e033931ad43597d96D6bcc25c280717730B58B1",
  },
  {
    name: "EtherFi",
    poolAddress: "0x0AA97c284e98396202b6A04024F5E2c65026F3c0",
  },
] as const
